module.exports = __webpack_public_path__ + "static/media/AS.5c3bea29.svg";